import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVeryHigh = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -2 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22.5568 7.89225C23.4499 9.43919 23.4499 11.3451 22.5568 12.892L19.4438 18.2841C18.5507 19.8312 16.9 20.7842 15.1137 20.7842H8.88635C7.09997 20.7842 5.4493 19.8312 4.55615 18.2841L1.44321 12.892C0.55014 11.3451 0.550142 9.43919 1.44321 7.89224L4.55615 2.50012C5.4493 0.953046 7.09997 0 8.88635 0L15.1137 0C16.9 0 18.5507 0.953048 19.4438 2.50012L22.5568 7.89225Z",
		fill: "#FF2322"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.0008 13.9924C12.6636 13.9924 13.2008 14.5296 13.2008 15.1924C13.2008 15.8551 12.6636 16.3924 12.0008 16.3924C11.3381 16.3924 10.8008 15.8551 10.8008 15.1924C10.8008 14.5296 11.3381 13.9924 12.0008 13.9924ZM12.0008 4.39209C12.6578 4.39209 13.1849 4.93491 13.1656 5.5916L12.9818 11.8398C12.9662 12.3703 12.5316 12.7923 12.0008 12.7923C11.4701 12.7923 11.0355 12.3703 11.0199 11.8398L10.8361 5.5916C10.8167 4.93491 11.3438 4.39209 12.0008 4.39209Z",
		fill: "white"
	})]
});
export default SvgVeryHigh;
